import { Controller } from "@hotwired/stimulus"

// Drag & drop pour fichiers GeoJSON avec validation
export default class extends Controller {
  static targets = ["zone", "input", "placeholder", "fileInfo", "fileName", "fileMeta", "error"]

  dragOver(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  dragEnter(e) {
    e.preventDefault()
    this.zoneTarget.classList.add("border-orange-400", "bg-orange-50")
    this.zoneTarget.classList.remove("border-gray-300", "bg-gray-50")
  }

  dragLeave(e) {
    e.preventDefault()
    this.zoneTarget.classList.remove("border-orange-400", "bg-orange-50")
    this.zoneTarget.classList.add("border-gray-300", "bg-gray-50")
  }

  drop(e) {
    e.preventDefault()
    e.stopPropagation()
    this.zoneTarget.classList.remove("border-orange-400", "bg-orange-50")
    this.zoneTarget.classList.add("border-gray-300", "bg-gray-50")

    const files = e.dataTransfer.files
    if (files.length > 0) {
      this._processFile(files[0])
    }
  }

  fileSelected() {
    const file = this.inputTarget.files[0]
    if (file) this._processFile(file)
  }

  clear(e) {
    e.preventDefault()
    e.stopPropagation()
    this.inputTarget.value = ""
    this._showPlaceholder()
    this._hideError()
  }

  _processFile(file) {
    this._hideError()

    // Valider l'extension
    const validExtensions = [".json", ".geojson"]
    const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase()
    if (!validExtensions.includes(ext)) {
      this._showError("Format non supporté. Utilisez un fichier .geojson ou .json")
      return
    }

    // Valider la taille (max 50 MB)
    if (file.size > 50 * 1024 * 1024) {
      this._showError("Fichier trop volumineux (max 50 Mo)")
      return
    }

    // Transférer le fichier au input caché
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.inputTarget.files = dataTransfer.files

    // Valider le contenu (FeatureCollection)
    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result)
        if (data.type !== "FeatureCollection" || !Array.isArray(data.features)) {
          this._showError("Le fichier doit être une FeatureCollection GeoJSON valide")
          this.inputTarget.value = ""
          this._showPlaceholder()
          return
        }

        const count = data.features.length
        this._showFileInfo(file.name, `${count} feature${count > 1 ? "s" : ""} — ${this._formatSize(file.size)}`)

        // Passer la zone en vert
        this.zoneTarget.classList.remove("border-gray-300", "bg-gray-50", "border-orange-400", "bg-orange-50")
        this.zoneTarget.classList.add("border-green-300", "bg-green-50")
      } catch {
        this._showError("Impossible de lire le fichier JSON. Vérifiez le format.")
        this.inputTarget.value = ""
        this._showPlaceholder()
      }
    }
    reader.readAsText(file)
  }

  _showFileInfo(name, meta) {
    this.placeholderTarget.classList.add("hidden")
    this.fileInfoTarget.classList.remove("hidden")
    this.fileNameTarget.textContent = name
    this.fileMetaTarget.textContent = meta
  }

  _showPlaceholder() {
    this.placeholderTarget.classList.remove("hidden")
    this.fileInfoTarget.classList.add("hidden")
    this.zoneTarget.classList.remove("border-green-300", "bg-green-50")
    this.zoneTarget.classList.add("border-gray-300", "bg-gray-50")
  }

  _showError(msg) {
    this.errorTarget.textContent = msg
    this.errorTarget.classList.remove("hidden")
  }

  _hideError() {
    this.errorTarget.classList.add("hidden")
  }

  _formatSize(bytes) {
    if (bytes < 1024) return `${bytes} o`
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`
    return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`
  }
}
